import React, { useEffect, useState } from 'react'
import { FoundationsButton } from '../GenericComponents/button'
import { FoundationsInput } from '../GenericComponents/input'
import {
    useGetLogFileDataMutation,
    useSaveLog4netConfigMutation,
} from '../Redux/Admin_Tasks/Log4NetSlice'
import { useForm } from 'react-hook-form'
import { FoundationsForm } from '../GenericComponents/form'
import { FormValidation } from '../FormValidationsRules'
import { FoundationsCheckBox } from '../GenericComponents/checkbox'
import { FoundationsGenericToaster } from '../GenericComponents/FoundationsGenericToaster'

export interface LogData {
    TracerLog: string
    MaximumFileSize: string
    DeleteLogDays: number
    Delimiter: string
}

declare let window: any
const UnicornApp = window.unicornInstance as any
interface Log4netConfigFormProps extends LogData {
    logData: string | null
    onDisplayLog: (logfiletype: string) => Promise<void>
}
export function Log4netConfigForm(props: Log4netConfigFormProps) {
    const [selectedLogType, setSelectedLogType] = useState<string>('trace')
    const [wrapContent, setWrapContent] = useState<boolean>(false)
    const [getLogFileData, { data: fileData, error: fileError, isLoading: fileLoading }] =
        useGetLogFileDataMutation()
    const [
        saveLog4netConfig,
        { isLoading: saveLoading, isSuccess: saveSuccess, error: saveError },
    ] = useSaveLog4netConfigMutation()
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<LogData>()
    const [formData, setFormData] = useState<LogData>({
        TracerLog: props.TracerLog,
        MaximumFileSize: props.MaximumFileSize,
        DeleteLogDays: props.DeleteLogDays,
        Delimiter: props.Delimiter,
    })

    const handleDisplayLogClick = () => {
        getLogFileData(selectedLogType)
    }

    const handleWrapContentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setWrapContent(e.target.checked)
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }))
    }

    const handleSaveConfigClick = () => {
        if (saveLoading) {
            return // Prevent multiple submissions while loading
        }
        saveLog4netConfig(formData).unwrap()
    }

    useEffect(() => {
        if (saveSuccess) {
            FoundationsGenericToaster('success', 'Configuration saved successfully')
        } else if (saveError) {
            const errorMessage = saveError || 'Saving configuration failed'
            FoundationsGenericToaster('error', `Saving configuration failed - ${errorMessage}`)
        }
    }, [saveSuccess, saveError])

    return (
        <>
            <FoundationsForm id="log_form_el" submitFunction={handleSubmit(handleSaveConfigClick)}>
                <div className="row">
                    <div className="col-sm-12">
                        <FoundationsInput
                            classes="form-group row"
                            id="TextBox_TracerLog"
                            type="text"
                            name="TracerLog"
                            value={formData.TracerLog}
                            inputClasses=""
                            labelText="Log Path:"
                            data-additional_classes=""
                            errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                            labelClasses="col-sm-2 col-form-label"
                            onInput={(e: any) => {
                                handleInputChange(e)
                            }}
                            registerFunction={register}
                            registerRules={FormValidation.Log4Net.TextBoxTracerLog}
                            error={errors.TracerLog?.message}
                            registerName="TracerLog"
                            containerClasses="col-sm-3"
                        ></FoundationsInput>
                        <div style={{ height: '17px' }}>
                            <label
                                htmlFor="TracerLog"
                                className="error field-validation-error"
                            ></label>
                        </div>
                    </div>
                </div>
                {/* <div className="row">
                    <div className="col-sm-12">
                        <FoundationsInput
                            classes="form-group row"
                            id="Text_Box_App_ExLog"
                            type="text"
                            name="AppExceptionLog"
                            value={formData.AppExceptionLog}
                            inputClasses=""
                            labelText="App Exception Log Path:"
                            data-additional_classes=""
                            errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                            labelClasses="col-sm-2 col-form-label"
                            containerClasses='col-sm-3'
                            registerName="AppExceptionLog"
                            error={errors.AppExceptionLog?.message}
                            onInput={(e: any) => {
                                handleInputChange(e)
                            }}
                            registerFunction={register}
                            registerRules={FormValidation.Log4Net.TextBoxAppExLog}
                        />
                        <div style={{ height: "17px" }}><label htmlFor="AppExceptionLog" className="error field-validation-error"></label></div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <FoundationsInput
                            classes="form-group row"
                            id="Text_Box_UIExLog"
                            type="text"
                            name="UIExceptionLog"
                            value={formData.UIExceptionLog}
                            inputClasses=""
                            labelText="UI Exception Log Path:"
                            data-additional_classes=""
                            errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                            labelClasses="col-sm-2 col-form-label"
                            containerClasses='col-sm-3'
                            onInput={(e: any) => {
                                handleInputChange(e)
                            }}
                            registerFunction={register}
                            error={errors.UIExceptionLog?.message}
                            registerRules={FormValidation.Log4Net.TextBoxUIExLog}
                            registerName="UIExceptionLog"
                        />
                        <div style={{ height: "17px" }}><label htmlFor="UIExceptionLog" className="error field-validation-error"></label></div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <FoundationsInput
                            classes="form-group row"
                            id="Text_Box_DBPerfLog"
                            type="text"
                            name="DBPerfLog"
                            data-value={formData.DBPerfLog}
                            inputClasses=""
                            labelText="DBPerf Log Path:"
                            data-additional_classes=""
                            data-error_col="col-12 offset-lg-3 col-lg-9 text-left"
                            labelClasses="col-sm-2 col-form-label"
                            containerClasses='col-sm-3'
                            onInput={(e: any) => {
                                handleInputChange(e)
                            }}
                            registerFunction={register}
                            registerRules={FormValidation.Log4Net.TextBoxDBPerfLog}
                            error={errors.DBPerfLog?.message}
                            registerName="DBPerfLog"
                        />
                        <div style={{ height: "17px" }}><label htmlFor="DBPerfLog" className="error field-validation-error"></label></div>
                    </div>
                </div> */}
                <div className="row">
                    <div className="col-sm-12">
                        <FoundationsInput
                            classes="form-group row"
                            id="Text_Box_LogFileSize"
                            type="number"
                            name="MaximumFileSize"
                            value={formData.MaximumFileSize.toString()}
                            inputClasses=""
                            labelText="Maximum File size(in MB):"
                            data-additional_classes=""
                            errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                            labelClasses="col-sm-2 col-form-label"
                            containerClasses="col-sm-3"
                            onInput={(e: any) => {
                                handleInputChange(e)
                            }}
                            registerFunction={register}
                            registerRules={FormValidation.Log4Net.TextBoxLogFileSize}
                            error={errors.MaximumFileSize?.message}
                            registerName="MaximumFileSize"
                        />
                        <div style={{ height: '17px' }}>
                            <label
                                htmlFor="MaximumFileSize"
                                className="error field-validation-error"
                            ></label>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <FoundationsInput
                            classes="form-group row"
                            id="Text_Box_LogDeleteDays"
                            type="number"
                            name="DeleteLogDays"
                            value={formData.DeleteLogDays}
                            inputClasses=""
                            labelText="Delete log before(days):"
                            data-additional_classes=""
                            errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                            labelClasses="col-sm-2 col-form-label"
                            containerClasses="col-sm-3"
                            onInput={(e: any) => {
                                handleInputChange(e)
                            }}
                            registerFunction={register}
                            registerRules={FormValidation.Log4Net.TextBoxLogDeleteDays}
                            error={errors.DeleteLogDays?.message}
                            registerName="DeleteLogDays"
                        />
                        <div style={{ height: '17px' }}>
                            <label
                                htmlFor="DeleteLogDays"
                                className="error field-validation-error"
                            ></label>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <FoundationsInput
                            classes="form-group row"
                            id="Text_Box_Delimiter"
                            type="text"
                            name="Delimiter"
                            value={formData.Delimiter.toString()}
                            inputClasses=""
                            labelText="Enter Custom Delimiter:"
                            data-additional_classes=""
                            errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                            labelClasses="col-sm-2 col-form-label"
                            containerClasses="col-sm-3"
                            onInput={(e: any) => {
                                handleInputChange(e)
                            }}
                            registerFunction={register}
                            registerRules={FormValidation.Log4Net.TextBoxLogCustomDelimiter}
                            error={errors.Delimiter?.message}
                            registerName="Delimiter"
                        />
                        <div style={{ height: '17px' }}>
                            <label
                                htmlFor="Delimiter"
                                className="error field-validation-error"
                            ></label>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-left">
                        <FoundationsButton
                            type="submit"
                            classes="offset-lg-4 col-4 p-l-0"
                            data-id="Save_Config"
                            id="button_saveConfig"
                            buttonClasses="app-button"
                            disabled={false}
                            data-additional_classes=""
                            isLoading={saveLoading}
                        >
                            Save Config
                        </FoundationsButton>
                    </div>
                </div>
            </FoundationsForm>
            <div className="row">
                <div className="col">
                    <div className="header">Display Log Files</div>
                </div>
            </div>
            <div className="padding-top-large"></div>

            {/* <div className="row">                    Commenting out for FP-10395
                <div className="col-sm-12">
                    <FoundationsSelect
                        classes="form-group row" id="logfile_type"
                        data-id='logfiletype' labelText="Choose LogFile: "
                        labelClasses='col-sm-2'
                        errorClasses='col-12 offset-lg-3 col-lg-9 text-left'
                        containerClasses='col-sm-3'
                        onChange={(e: any) => {
                            handleSelectChange(e)
                        }}>
                        <option value="trace">Tracer Log</option>
                        <option value="appexp">App Exception Log</option>
                        <option value="uiexp">UI Exception Log</option>
                        <option value="dbperf">DBPerf Log</option>
                    </FoundationsSelect>
                </div>
            </div> */}
            <div className="row">
                <div className="col-sm-4">
                    <FoundationsCheckBox
                        id="wrapContent_CheckBox"
                        name="DisplayInPalette"
                        value="Wrapcontent"
                        checked={wrapContent}
                        onChange={handleWrapContentChange}
                        inputClasses="checkbox-height col-1"
                        errorClasses="col-sm-12 offset-md-2 col-md-10"
                        labelText="Wrap Content"
                    />
                </div>
                <div className="col-sm-4">
                    <FoundationsButton
                        classes="offset-lg-3 col-4 p-l-0"
                        data-id="displayLogs"
                        id="display_Logs"
                        buttonClasses="app-button"
                        disabled={false}
                        data-additional_classes=""
                        onClick={handleDisplayLogClick}
                        isLoading={fileLoading}
                        customStyle={{ marginLeft: '-1.666667%' }}
                    >
                        Display Log
                    </FoundationsButton>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <div
                        style={{
                            overflowY: wrapContent ? undefined : 'auto',
                            whiteSpace: wrapContent ? undefined : 'nowrap',
                            overflowX: 'auto',
                            maxWidth: '100%',
                            maxHeight: '40em',
                        }}
                        id="LogsFileData"
                        dangerouslySetInnerHTML={{ __html: fileData }}
                    ></div>
                </div>
            </div>
        </>
    )
}
